import { FunctionField } from "react-admin";
import { PetType } from "../../../Pages/User/Constant/PetType";

const PetsField = () => {
    const getPetName = (pet) => {
        return pet?.name ? pet.name : ''
    }

    const getPetType = (pet) => {
        const petType = PetType.find((el) => el.id === pet?.petType)?.name
        return petType ? `(${petType})` : ''
    }

    return <FunctionField
        render={(record) => {
            if (record?.pets?.length) {
                return record.pets.map((pet) => `${getPetName(pet)} (${getPetType(pet)})`)?.length
                    ? record.pets.map((pet) => `${getPetName(pet)} ${getPetType(pet)}`).join(", ")
                    : ""
            } else {
                return ''
            }
        }}
    />
};

export default PetsField;
